import React from 'react';
import { hapticTick } from '../../../_utils/haptics';
import { when } from '../bailey/format';
import { dialable } from './api';
import { contactOf } from './needs';

/**
 * One message Bailey took for the salon: who, what they wanted, and the way
 * to get back to them. Done is on the left, the positive action on the right.
 * Shown in the Done history on Conversations › Messages; waiting messages
 * show one card per person (NeedsYou.js).
 */
export default function MessageCard({ message, onDone, onReopen, doneAt = null, full = false }) {
    const m = message;
    // A number and an email are often saved as one ("07700 900284 / sarah@example.com").
    const { phone, email } = contactOf(m.contact);
    const who = m.name || 'A client';
    const title = phone ? `${who} wants a call back` : email ? `${who} would like a reply` : `${who} left a message`;
    const took = m.channel ? (/voice|phone|call/i.test(m.channel) ? 'on the phone' : 'on your booking page') : null;
    const meta = [took && `Bailey took it ${took}`, m.at && when(m.at), doneAt && doneWhen(doneAt)].filter(Boolean).join(' · ');
    if (doneAt) {
        return (
            <div className="bly-card fd-message is-done">
                <span className="bly-tile" aria-hidden="true">{phone ? '📞' : '💬'}</span>
                <div className="fd-message-copy">
                    <b>{title}</b>
                    {m.text && <span className="fd-message-text">{m.text}</span>}
                    <small>{[m.contact, meta].filter(Boolean).join(' · ')}</small>
                </div>
                {onReopen && (
                    <div className="bly-actions">
                        <button type="button" className="bly-btn is-ghost" onClick={() => { hapticTick(); onReopen(m.id); }}>Not done</button>
                    </div>
                )}
            </div>
        );
    }
    return (
        <div className="bly-card fd-message">
            <span className="bly-tile" aria-hidden="true">{phone ? '📞' : '💬'}</span>
            <div className="fd-message-copy">
                <b>{title}</b>
                {m.text && <span className="fd-message-text">{full ? m.text : shorten(m.text)}</span>}
                {(meta || m.contact) && (
                    <small>{[m.contact, meta].filter(Boolean).join(' · ')}</small>
                )}
            </div>
            <div className="bly-actions">
                <button type="button" className="bly-btn is-ghost" onClick={() => { hapticTick(); onDone(m.id); }}>Done</button>
                {email && (
                    <a className={`bly-btn ${phone ? 'is-secondary' : 'is-primary'}`} href={`mailto:${email}`} onClick={() => hapticTick()}>Reply</a>
                )}
                {phone && (
                    <a className="bly-btn is-primary" href={`tel:${dialable(phone)}`} onClick={() => hapticTick()}>Call back</a>
                )}
            </div>
        </div>
    );
}

/** "Done yesterday", "Done Tue", "Done 2:14pm". */
function doneWhen(at) {
    const w = when(at);
    return `Done ${/^(Just now|Yesterday)$/.test(w) ? w.toLowerCase() : w}`;
}

function shorten(text, max = 140) {
    const t = String(text || '').trim();
    if (t.length <= max) return t;
    return `${t.slice(0, max - 1).replace(/\s+\S*$/, '')}…`;
}
